import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import styled from "styled-components";

export const Loading = ({ full }) => {
	const LoadingIcon = ({ size }) => (
		<LoadingOutlined style={{ fontSize: size }} spin></LoadingOutlined>
	);

	return full ? (
		<StyledSpinner indicator={<LoadingIcon size={100}></LoadingIcon>} />
	) : (
		<Spin indicator={<LoadingIcon size={24}></LoadingIcon>}></Spin>
	);
};

const StyledSpinner = styled(Spin)`
	position: relative;
	top: 30%;
	left: 50%;
	transform: translate(-50%, -50%);
`;
